<template>
  <v-container fluid style="max-width: 1280px;">
    <v-layout alig-start>
      <v-flex>
        <!-- Inicio de barra de alerta -->
        <v-snackbar v-model="alerta.snackbar" :color="alerta.color" @click="alerta.snackbar = false">{{ alerta.text
        }}</v-snackbar>
        <!-- Fin inicio de barra de alerta -->

        <!-- Listado de personales y opciones de titulo, busqueda, nuevo, etc -->
        <v-data-table :loading="loading" :headers="cabPersonal" :items="personales" :items-per-page="15"
          :search="buscar" class="elevation-3" dense>
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title class="hidden-sm-and-down">PERSONAL</v-toolbar-title>
              <v-divider class="mx-4 hidden-sm-and-down" inset vertical></v-divider>

              <!-- Impresion area -->
              <v-btn text fab x-small color="accent" @click="crearPDF()" class="mr-1">
                <v-icon>description</v-icon>
              </v-btn>
              <!-- Fin Impresion area -->

              <v-spacer />
              <!-- Formulario busqueda de persona -->
              <v-text-field class="text-xs-center" v-model.trim="buscar" @keyup="listar()" append-icon="search"
                v-uppercase dense label="Búsqueda" hide-details></v-text-field>
              <!-- Fin Formulario Busqueda de persona -->
              <v-spacer />
              <!-- Modal crear y modificar persona -->
              <v-dialog v-model="dialog" max-width="600px" persistent>
                <template v-slot:activator="{ on }">
                  <v-btn fab x-small color="primary" v-on="on">
                    <v-icon>add</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar dark dense class="primary">
                    <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                    <v-spacer />
                    <strong>{{ nrodoc }}</strong>
                    <v-spacer />
                    <v-btn icon dark @click="guardar" :loading="desabilitar" :disabled="desabilitar || !isValid">
                      <v-icon>save</v-icon>
                    </v-btn>
                    <v-btn icon dark @click="close">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-form v-model="isValid">
                      <v-row class="mt-2">
                        <v-col cols="12" sm="4">
                          <v-text-field dense v-model.trim="nrodoc" label="DNI" maxlength="8"
                            @keyup.enter="buscarPersona()"
                            :rules="[v => !!v || 'requerido', v => (!!v && v.length >= 8 && v.length < 9) || 'Nombre debe tener entre 3 a 8 caracteres']"
                            v-mask-number hide-details append-icon="search"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="8">
                          <v-text-field dense v-model.trim="nombres" label="Nombres"
                            :rules="[v => !!v || 'requerido', Rules.unespacio]" maxlength="30" v-uppercase
                            hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" md="7" sm="8">
                          <v-text-field dense v-model.trim="apellidos" label="Apellidos"
                            :rules="[v => !!v || 'requerido', Rules.unespacio]" maxlength="30" v-uppercase
                            hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" md="5" sm="4">
                          <v-select dense :items="selectModconts" v-model="modcont" label="Modalidad"
                            :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field dense v-model.trim="telefono" label="Telefono" :rules="[
                            v => !v || v.length >= 9 || 'Debe tener al menos 9 dígitos'
                          ]" maxlength="20" prepend-inner-icon="phone" hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field dense v-model.trim="email" label="Email" :rules="[
                            v => !v || /.+@.+\..+/.test(v) || 'Ingrese un email válido',
                            Rules.sinespacio
                          ]" maxlength="50" prepend-inner-icon="mail" v-lowercase hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-text-field dense v-model.trim="direccion" label="Direccion" :rules="[
                            v => !v || v.length >= 8 || 'La dirección debe tener al menos 8 caracteres',
                            Rules.unespacio
                          ]" maxlength="60" prepend-inner-icon="place" v-uppercase hide-details></v-text-field>
                        </v-col>

                        <!-- Mensaje error persona -->
                        <v-col cols="12" v-if="mensajeError != ''">
                          <v-alert text dense type="error">{{ mensajeError }}</v-alert>
                        </v-col>
                        <!-- Mensaje error persona -->
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-dialog>
              <!-- Fin Modal crear y modificar persona -->

              <!-- Modal asignar area -->
              <v-dialog v-model="dialogPersonaArea" max-width="950" persistent>
                <v-data-table :loading="loadingAsig" :headers="cabAsignar" :items="asignaciones" class="elevation-3"
                  dense>
                  <template v-slot:top>
                    <v-toolbar dark dense class="primary">
                      <v-toolbar-title>Asignaciones:</v-toolbar-title>
                      <v-spacer />
                      <strong>{{ nombres }}</strong>
                      <v-spacer />
                      <v-dialog v-model="dialogArea" max-width="600px" persistent>
                        <template v-slot:activator="{ on }">
                          <v-btn icon dark v-on="on" @click="close">
                            <v-icon>close</v-icon>
                          </v-btn>
                          <v-btn icon v-on="on">
                            <v-icon>add</v-icon>
                          </v-btn>
                        </template>
                        <v-card>
                          <v-toolbar dark dense class="primary">
                            <v-toolbar-title>{{ formTitleAsig }}</v-toolbar-title>
                            <v-spacer />
                            <v-btn icon dark @click="guardarAsig" :loading="desabilitar"
                              :disabled="desabilitar || !isValid">
                              <v-icon>save</v-icon>
                            </v-btn>
                            <v-btn icon dark @click="closeArea">
                              <v-icon>close</v-icon>
                            </v-btn>
                          </v-toolbar>
                          <v-card-text>
                            <v-form v-model="isValid">
                              <v-row class="mt-2">
                                <v-col cols="12" sm="12">
                                  <v-autocomplete dense @keyup="selectLocal()" :search-input.sync="buscar_local"
                                    v-model.trim="idlocal" :items="selectLocalArray" label="Local"
                                    :rules="[v => !!v || 'Requerido']"
                                    @change="selectAreaArray = [], selectOficinaArray = [], idarea = null, idoficina = '', selectArea()"
                                    hide-details></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="9">
                                  <v-select dense v-model.trim="idarea" :items="selectAreaArray" label="Area"
                                    :rules="[v => !!v || 'Requerido']"
                                    @change="selectOficinaArray = [], idoficina = '', selectOficina()"
                                    :disabled="idlocal == null ? true : false" hide-details></v-select>
                                </v-col>
                                <v-col cols="12" sm="3">
                                  <v-select dense v-model.trim="idoficina" :items="selectOficinaArray" label="Oficina"
                                    :rules="[v => !!v || 'Requerido']" :disabled="idarea == null ? true : false"
                                    hide-details></v-select>
                                </v-col>
                                <!-- Mensaje error asignacion -->
                                <v-col cols="12" v-if="mensajeError != ''">
                                  <v-alert text dense type="error">{{ mensajeError }}</v-alert>
                                </v-col>
                                <!-- Mensaje error asignacion -->
                              </v-row>
                            </v-form>
                          </v-card-text>
                        </v-card>
                      </v-dialog>
                      <!-- Modal activar, desactivar asignacion -->
                      <v-dialog v-model="adModalAsig" max-width="400">
                        <v-card>
                          <v-card-title class="headline" v-if="adAccionAsig == 1">¿Activar Asignación?</v-card-title>
                          <v-card-title class="headline" v-if="adAccionAsig == 2">¿Desactivar Asignacion?</v-card-title>
                          <v-card-text>
                            Estás a punto de
                            <span v-if="adAccionAsig == 1">Activar</span>
                            <span v-if="adAccionAsig == 2">Desactivar</span>
                            la asignacion {{ adNombreAsig }}
                          </v-card-text>
                          <v-card-actions class="py-0 pb-4 justify-center">
                            <v-btn text x-small color="error" @click="activarDesactivarCerrarAsig">Cancelar</v-btn>
                            <v-btn v-if="adAccionAsig == 1" text x-small color="success"
                              @click="activarAsig">Activar</v-btn>
                            <v-btn v-if="adAccionAsig == 2" text x-small color="warning"
                              @click="desactivarAsig">Desactivar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <!-- Fin Modal activar, desactivar asignacion -->
                    </v-toolbar>
                  </template>
                  <!-- Opciones editar, eliminar asignacion -->
                  <template v-slot:item.ubicacion="{ item }">
                    <div class="text-caption">
                      <v-icon x-small color="info">location_city</v-icon>
                      {{ item.nomlocales }}
                    </div>
                    <div class="ml-1 text-caption">
                      <v-icon x-small color="info">hub</v-icon>
                      {{ item.nomareas }}
                    </div>
                    <div class="ml-2 text-caption">
                      <v-icon x-small color="info">meeting_room</v-icon>
                      <strong> {{ item.nomoficinas }}</strong>
                    </div>
                  </template>

                  <template v-slot:item.cantbienabe="{ item }">
                    <v-chip x-small :color="item.cantbiena == 0 ? 'grey' : 'primary'" label text-color="white">
                      <strong>{{ item.cantbiena }}</strong>
                    </v-chip>
                    <v-chip x-small :color="item.cantbienb == 0 ? 'grey' : 'warning'" label text-color="white"
                      class="mx-1">
                      <strong>{{ item.cantbienb }}</strong>
                    </v-chip>
                    <v-chip x-small :color="item.cantbiene == 0 ? 'grey' : 'error'" label text-color="white">
                      <strong>{{ item.cantbiene }}</strong>
                    </v-chip>
                  </template>

                  <template v-slot:item.condicion="{ item }">
                    <template v-if="item.condicion">
                      <v-btn text x-small color="success" @click="activarDesactivarMostrarAsig(2, item)">Activo</v-btn>
                    </template>
                    <template v-else>
                      <v-btn text x-small color="warning"
                        @click="activarDesactivarMostrarAsig(1, item)">Inactivo</v-btn>
                    </template>
                  </template>
                  <template v-slot:item.opciones="{ item }">
                    <v-btn x-small icon>
                      <v-icon color="info" @click="editAsignacionItem(item)">edit</v-icon>
                    </v-btn>
                    <v-btn x-small icon v-if="item.cantbiena + item.cantbienb + item.cantbiene == 0">
                      <v-icon color="error" @click="deleteItemAsig(item)">delete_forever</v-icon>
                    </v-btn>
                  </template>
                  <!-- Fin Opciones editar, eliminar asignacion -->
                </v-data-table>
              </v-dialog>
              <!-- Fin Modal asignar area -->

              <!-- Modal activar, desactivar personal -->
              <v-dialog v-model="adModal" max-width="400">
                <v-card>
                  <v-card-title class="headline justify-center" v-if="adAccion == 1">¿Activar Personal?</v-card-title>
                  <v-card-title class="headline justify-center" v-if="adAccion == 2">¿Desactivar
                    Personal?</v-card-title>
                  <v-card-text>
                    Estás a punto de
                    <span v-if="adAccion == 1">Activar</span>
                    <span v-if="adAccion == 2">Desactivar</span>
                    el personal {{ adNombre }}
                  </v-card-text>
                  <v-card-actions class="py-0 pb-4 justify-center">
                    <v-btn text x-small color="error" @click="activarDesactivarCerrar">Cancelar</v-btn>
                    <v-btn v-if="adAccion == 1" text x-small color="success" @click="activar">Activar</v-btn>
                    <v-btn v-if="adAccion == 2" text x-small color="warning" @click="desactivar">Desactivar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- Fin Modal activar, desactivar personal -->
            </v-toolbar>
          </template>
          <!-- Opciones editar, eliminar persona -->

          <template v-slot:item.areas="{ item }">
            <v-badge :content="item.cantasignacion" :value="item.cantasignacion > 0" color="info" overlap offset-x="10"
              offset-y="10">
              <v-btn text x-small color="info" @click="mostrarListaAsignacionItem(item)">
                Asignar
              </v-btn>
            </v-badge>
          </template>

          <template v-slot:item.cantbien="{ item }">
            <v-chip x-small :color="item.cantbien == 0 ? 'grey' : 'primary'" label text-color="white">
              <strong>{{ item.cantbien }}</strong>
            </v-chip>
          </template>

          <template v-slot:item.condicion="{ item }">
            <template v-if="item.condicion">
              <v-btn text x-small color="success" @click="activarDesactivarMostrar(2, item)">Activo</v-btn>
            </template>
            <template v-else>
              <v-btn text x-small color="warning" @click="activarDesactivarMostrar(1, item)">Inactivo</v-btn>
            </template>
          </template>

          <template v-slot:item.opciones="{ item }">
            <v-btn x-small icon>
              <v-icon color="info" @click="editItem(item)">edit</v-icon>
            </v-btn>
            <v-btn x-small icon>
              <v-icon color="error" @click="deleteItem(item)">delete_forever</v-icon>
            </v-btn>
          </template>
          <!-- Fin Opciones editar, eliminar persona -->
        </v-data-table>
        <!-- Fin Listado de personales y opciones de titulo, busqueda, nuevo, etc -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import jsPDF from "jspdf";
import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      personales: [],
      asignaciones: [],
      dialog: false,
      dialogPersonaArea: 0,
      dialogArea: 0,

      cabPersonal: [
        { text: "CdPs", value: "idpersonal" },
        { text: "DNI", value: "nrodoc", sortable: false },
        { text: "Nombres", value: "nombres", sortable: false },
        { text: "Apellidos", value: "apellidos", sortable: false },
        { text: "Ubicación", value: "areas", sortable: false },
        { text: "Nº Bienes", value: "cantbien", sortable: false, align: "center" },
        { text: "Condición", align: "center", value: "condicion", sortable: false },
        { text: "Opc.", value: "opciones", sortable: false },
      ],

      cabAsignar: [
        { text: "CdAs", value: "idasignacion" },
        { text: "Ubicación", value: "ubicacion", sortable: false },
        { text: "Bienes | Bajas | Otros", value: "cantbienabe", sortable: false, align: "center" },
        { text: "Condición", align: "center", value: "condicion", sortable: false },
        { text: "OPC.", value: "opciones", sortable: false },
      ],

      buscar: "",
      editedIndex: -1,
      editedIndexAsig: -1,
      idasignacion: "",
      idpersonal: "",
      nombres: "",
      apellidos: "",
      nrodoc: "",
      modcont: "", // selectModconts
      email: "",
      telefono: "",
      direccion: "",

      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",

      adModalAsig: 0,
      adAccionAsig: 0,
      adNombreAsig: "",
      adIdAsig: "",

      idlocal: null, // Buscar area
      idarea: null,
      idoficina: null,
      selectLocalArray: [],
      buscar_local: "",
      selectAreaArray: [],
      buscar_area: "",
      selectOficinaArray: [],
      buscar_oficina: "",

      mensajeError: "",

      loadingAsig: "",

      selectModconts: [
        { text: "CAS", value: "C" },
        { text: "FUNCIONARIO", value: "F" },
        { text: "PRACTICANTE", value: "P" },
        { text: "SECIGRISTA", value: "S" },
        { text: "SERVIDOR PUBLICO", value: "E" },
        { text: "TERCERO", value: "T" },
      ],

      desabilitar: false,
      isValid: true,
      alerta: { snackbar: false, color: "", text: "" },

      /* Validaciones */
      Rules: {
        sinespacio: (v) =>
          (v || "").indexOf(" ") < 0 || "No se permite espacios",
        unespacio: (v) =>
          (v || "").indexOf("  ") < 0 || "No se permite mas de 1 espacio",
      },
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Personal" : "Actualizar Personal";
    },

    formTitleAsig() {
      return this.editedIndexAsig === -1
        ? "Nueva Asignación"
        : "Actualizar Asignación";
    },

    ...mapGetters(["esSuperadministrador"]),
    ...mapState(["usuarioState", "empresaState"]),
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
  },

  methods: {
    /* Listar personales */
    listar() {
      let me = this;
      me.loading = true;

      // Busqueda para administrador
      axios
        .get("api/Personales/ListarPersonalEmpresaFiltro", {
          params: {
            idempresa: me.usuarioState.idempresa,
            buscar: me.buscar == "" ? "-" : me.buscar,
          },
        })
        .then(function (response) {
          me.personales = response.data;
          me.loading = false;
        })
        .catch((err) => {
          //console.log(err.response);
        });
    },

    /* Editar y guardar persona */
    guardar() {
      let me = this;
      me.desabilitar = true;

      if (me.editedIndex > -1) {
        //Código para editar
        axios
          .put("api/Personales/Actualizar", {
            idpersonal: me.idpersonal,
            idempresa: me.usuarioState.idempresa,
            idusuario: me.usuarioState.idusuario,
            nombres: me.nombres,
            apellidos: me.apellidos,
            nrodoc: me.nrodoc,
            modcont: me.modcont,
            email: me.email,
            telefono: me.telefono,
            direccion: me.direccion,
          })
          .then(function (response) {
            me.desabilitar = false;
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.mensajeError = error.response.data;
            me.limpiarAlertaError();
          });
      } else {
        //Código para guardar
        axios
          .post("api/Personales/Crear", {
            idempresa: me.usuarioState.idempresa,
            idusuario: me.usuarioState.idusuario,
            nombres: me.nombres,
            apellidos: me.apellidos,
            nrodoc: me.nrodoc,
            modcont: me.modcont,
            email: me.email,
            telefono: me.telefono,
            direccion: me.direccion,
          })
          .then(function (response) {
            me.desabilitar = false;
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.mensajeError = error.response.data;
            me.limpiarAlertaError();
          });
      }
    },
    /* Fin Editar y guardar persona */

    /* Limpiar mensaje persona */
    limpiarAlertaError() {
      setTimeout(() => {
        this.mensajeError = "";
      }, 3000);
    },
    /* Fin Limpiar mensaje persona */

    /* Editar persona item */
    editItem(item) {
      this.idpersonal = item.idpersonal;
      this.nombres = item.nombres;
      this.apellidos = item.apellidos;
      this.nrodoc = item.nrodoc;
      this.modcont = item.modcont;
      this.email = item.email;
      this.telefono = item.telefono;
      this.direccion = item.direccion;
      this.editedIndex = 1;
      this.dialog = true;
    },
    /* Fin Editar persona item */

    /* Cerrar ventana persona */
    close() {
      this.dialog = false;
      this.dialogPersonaArea = 0;
      this.asignaciones = [];
      this.listar();
      this.limpiar();
    },

    closeArea() {
      this.dialogArea = 0;
      this.idlocal = null; // Para bloquear select Area
      this.idarea = null;
      this.idoficina = "";
      this.selectAreaArray = [];
      this.selectOficinaArray = [];
      this.limpiarAsig();
    },
    /* Fin Cerrar ventana persona */

    /* Limpiar persona item */
    limpiar() {
      this.idpersonal = "";
      this.nombres = "";
      this.apellidos = "";
      this.nrodoc = "";
      this.modcont = "";
      this.email = "";
      this.telefono = "";
      this.direccion = "";
      this.mensajeError = "";

      this.idasignacion = "";

      this.editedIndex = -1;
    },
    /* Fin Limpiar persona item */

    /* Limpiar asignacion item */
    limpiarAsig() {
      this.editedIndexAsig = -1;
      this.mensajeError = "";
    },
    /* Fin Limpiar asignacion item */

    /* Desactivar, activar personal */
    desactivar() {
      let me = this;

      axios
        .put("api/Personales/Desactivar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    activarDesactivarMostrar(accion, item) {
      this.adModal = 1;
      this.adNombre = item.nombres;
      this.adId = item.idpersonal;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else {
        this.adModal = 0;
      }
    },

    activarDesactivarCerrar() {
      this.adModal = 0;
    },

    activar() {
      let me = this;
      axios
        .put("api/Personales/Activar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    /* Fin Desactivar, activar personal */

    /* Eliminar personal */
    deleteItem(item) {
      const respta = confirm(
        "¿Estás seguro de que deseas eliminar al personal " + item.nombres + "?"
      );
      if (respta) {
        let me = this;
        axios
          .delete("api/Personales/Eliminar/" + item.idpersonal)
          .then((response) => {
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            this.listar();
          })
          .catch(function (error) {
            me.alerta.snackbar = true;
            me.alerta.color = "error";
            me.alerta.text = error.response.data;
          });
      }
    },
    /* Fin Eliminar personal */

    /* Listar asignacion */
    listarAsignacion(id) {
      let me = this;
      me.loadingAsig = true;

      // Busqueda para administrador
      axios
        .get("api/Asignaciones/ListarAsignacionEmpresaFiltro", {
          params: {
            idempresa: me.usuarioState.idempresa,
            idpersonal: id,
          },
        })
        .then(function (response) {
          me.asignaciones = response.data;
          me.loadingAsig = false;
        })
        .catch((err) => {
          //console.log(err.response);
        });
    },
    /* Fin Listar asignacion */

    /* Select local */
    selectLocal(id) {
      let me = this;
      var localArray = [];

      if (id) {
        // Select idlocal
        axios
          .get("api/Locales/SelectLocal?idlocal=" + (id == null ? "-" : id))
          .then(function (response) {
            localArray = response.data;
            localArray.map(function (x) {
              me.selectLocalArray.push({
                text: x.locales,
                value: x.idlocal,
              });
            });
          })
          .catch(function (error) {
            //console.log(url);
          });
      } else {
        // Select local para area de la empresa
        axios
          .get("api/Locales/SelectLocalesFiltro", {
            params: {
              idempresa: me.usuarioState.idempresa,
              buscar:
                me.buscar_local == ""
                  ? "-"
                  : me.buscar_local == null
                    ? "-"
                    : me.buscar_local,
            },
          })
          .then(function (response) {
            localArray = response.data;
            localArray.map(function (x) {
              me.selectLocalArray.push({
                text: x.locales,
                value: x.idlocal,
              });
            });
          })
          .catch((err) => {
            //console.log(err.response);
          });
      }
    },

    selectArea(id) {
      let me = this;
      var areaArray = [];

      if (id) {
        // Select idarea
        axios
          .get("api/Areas/SelectArea?idarea=" + (id == null ? "-" : id))
          .then(function (response) {
            areaArray = response.data;
            areaArray.map(function (x) {
              me.selectAreaArray.push({
                text: x.areas,
                value: x.idarea,
              });
            });
          })
          .catch(function (error) {
            //console.log(url);
          });
      } else {
        // Select areas para local
        axios
          .get("api/Areas/SelectAreasFiltro", {
            params: {
              idlocal: me.idlocal,
            },
          })
          .then(function (response) {
            areaArray = response.data;
            areaArray.map(function (x) {
              me.selectAreaArray.push({
                text: x.areas,
                value: x.idarea,
              });
            });
          })
          .catch((err) => {
            //console.log(err.response);
          });
      }
    },

    selectOficina(id) {
      let me = this;
      var oficinaArray = [];

      if (id) {
        // Select idoficina
        axios
          .get("api/Oficinas/SelectOficina?idoficina=" + (id == null ? "-" : id))
          .then(function (response) {
            oficinaArray = response.data;
            oficinaArray.map(function (x) {
              me.selectOficinaArray.push({
                text: x.oficinas,
                value: x.idoficina,
              });
            });
          })
          .catch(function (error) {
            //console.log(url);
          });
      } else {
        // Select oficinas
        axios
          .get("api/Oficinas/SelectOficinasFiltro", {
            params: {
              idarea: me.idarea,
            },
          })
          .then(function (response) {
            oficinaArray = response.data;
            oficinaArray.map(function (x) {
              me.selectOficinaArray.push({
                text: x.oficinas,
                value: x.idoficina,
              });
            });
          })
          .catch((err) => {
            //console.log(err.response);
          });
      }
    },
    /* Fin Select local */

    /* Editar y guardar asignacion */
    guardarAsig() {
      let me = this;
      me.desabilitar = true;

      if (me.editedIndexAsig > -1) {
        //Código para editar
        axios
          .put("api/Asignaciones/Actualizar", {
            idempresa: me.usuarioState.idempresa,
            idasignacion: me.idasignacion,
            idlocal: me.idlocal,
            idoficina: me.idoficina,
            idpersonal: me.idpersonal,
          })
          .then(function (response) {
            me.desabilitar = false;
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            me.closeArea();
            me.listarAsignacion(me.idpersonal);
            me.limpiarAsig();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.mensajeError = error.response.data;
            me.limpiarAlertaError();
          });
      } else {
        //Código para guardar
        axios
          .post("api/Asignaciones/Crear", {
            idempresa: me.usuarioState.idempresa,
            idlocal: me.idlocal,
            idoficina: me.idoficina,
            idpersonal: me.idpersonal,
          })
          .then(function (response) {
            me.desabilitar = false;
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            me.closeArea();
            me.listarAsignacion(me.idpersonal);
            me.limpiarAsig();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.mensajeError = error.response.data;
            me.limpiarAlertaError();
          });
      }
    },
    /* Fin Editar y guardar asignacion */

    /* Desactivar, activar asignacion */
    desactivarAsig() {
      let me = this;

      axios
        .put("api/Asignaciones/Desactivar/" + this.adIdAsig, {})
        .then(function (response) {
          me.adModalAsig = 0;
          me.adAccionAsig = 0;
          me.adNombreAsig = "";
          me.adIdAsig = "";
          me.listarAsignacion(me.idpersonal);
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    activarDesactivarMostrarAsig(accion, item) {
      this.adModalAsig = 1;
      this.adNombreAsig = item.nomoficinas;
      this.adIdAsig = item.idasignacion;
      if (accion == 1) {
        this.adAccionAsig = 1;
      } else if (accion == 2) {
        this.adAccionAsig = 2;
      } else {
        this.adModalAsig = 0;
      }
    },

    activarDesactivarCerrarAsig() {
      this.adModalAsig = 0;
    },

    activarAsig() {
      let me = this;
      axios
        .put("api/Asignaciones/Activar/" + this.adIdAsig, {})
        .then(function (response) {
          me.adModalAsig = 0;
          me.adAccionAsig = 0;
          me.adNombreAsig = "";
          me.adIdAsig = "";
          me.listarAsignacion(me.idpersonal);
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    /* Fin Desactivar, activar asignacion */

    mostrarListaAsignacionItem(item) {
      this.idpersonal = item.idpersonal;
      this.nombres = item.nombres;
      this.listarAsignacion(item.idpersonal);
      this.selectLocal(); // Para nueva asignacion
      this.dialogPersonaArea = 1;
    },

    editAsignacionItem(item) {
      this.idasignacion = item.idasignacion;
      this.idlocal = item.idlocal;
      this.selectLocal(item.idlocal);
      this.idarea = item.idarea;
      this.selectArea(item.idarea);
      this.idoficina = item.idoficina;
      this.selectOficina(item.idoficina);

      this.dialogArea = 1;
      this.editedIndexAsig = 1;
    },

    /* Eliminar asignacion */
    deleteItemAsig(item) {
      const respta = confirm(
        "¿Estás seguro de que deseas eliminar la asignación " +
        item.nomoficinas +
        "?"
      );
      if (respta) {
        let me = this;
        axios
          .delete(
            "api/Asignaciones/Eliminar/" +
            item.idasignacion +
            "/" +
            item.nomoficinas
          )
          .then((response) => {
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            me.listarAsignacion(me.idpersonal);
          })
          .catch(function (error) {
            me.alerta.snackbar = true;
            me.alerta.color = "error";
            me.alerta.text = error.response.data;
          });
      }
    },
    /* Fin Eliminar asignacion */

    /* Buscar Persona */
    buscarPersona() {
      let me = this;
      axios
        .get("api/Personales/ConsultarDni", {
          params: {
            nrodoc: me.nrodoc,
          },
        })
        .then(function (response) {
          //console.log(response.data)
          if (response.data.exito == true) {
            me.nombres = response.data.nombres;
            me.apellidos = response.data.apellidoPaterno + " " + response.data.apellidoMaterno;
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data.mensaje;
          } else {
            me.nombres = "";
            me.apellidos = "";
            me.alerta.snackbar = true;
            me.alerta.color = "error";
            me.alerta.text = response.data.mensaje;
          }
        })
        .catch((err) => {
          //console.log(err.response);
        });
    },
    /* Fin Buscar Persona */

    /* Crear PDF Area */
    crearPDF() {
      var columns = [
        { header: "DNI", dataKey: "nrodoc" },
        { header: "NOMBRES", dataKey: "nombres" },
        { header: "APELLIDOS", dataKey: "apellidos" },
        { header: "Condicion", dataKey: "condicion" },
      ];
      var body = [];

      this.personales.map(function (x) {
        body.push({
          nrodoc: x.nrodoc,
          nombres: x.nombres,
          apellidos: x.apellidos,
          condicion: x.condicion == 1 ? "Activo" : "Inactivo",
        });
      });
      //console.log(body);
      // Agregar Encabezado: titulo y logo
      const addHeaders = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.text("LISTADO DE PERSONAL", doc.internal.pageSize.width / 2, 45, {
            align: "center",
          });
        }
      };
      // Agregar pie de pagina: numeración
      const addFooters = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFont("helvetica", "italic");
        doc.setFontSize(7);
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.text(
            "Pagina " + String(i) + " de " + String(pageCount),
            doc.internal.pageSize.width / 2,
            820,
            {
              align: "center",
            }
          );
        }
      };

      // Configurando hoja
      var imgData = "data:image/png;base64," + this.empresaState.logo;
      var doc = new jsPDF("p", "pt");

      doc.addImage(imgData, "JPEG", 40, 17, 35, 40);
      doc.autoTable({
        columns,
        body,
        margin: { top: 70 },
        headStyles: {
          fillColor: [46, 78, 121],
          fontSize: 7,
          halign: "center",
        },
        bodyStyles: { textColor: 0, fontSize: 8 },
        columnStyles: {
          nrodoc: { cellWidth: 80, halign: "center" },
          nombres: { cellWidth: 150 },
          apellidos: { cellWidth: 240 },
          condicion: { cellWidth: 45.28, halign: "center" },
        },
      });
      // 515 ancho hoja
      addHeaders(doc);
      addFooters(doc);
      doc.save("Personal.pdf");
    },
    /* Fin Crear PDF Area */
  },
};
</script>
